import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';

const convertKeysToCamelCase = function () {
  let obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return mapKeys(obj, (value, key) => camelCase(key));
};

export { convertKeysToCamelCase };
